import { render } from "./QuestionnaireListComponent.vue?vue&type=template&id=6f4335bf&scoped=true&ts=true"
import script from "./QuestionnaireListComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireListComponent.vue?vue&type=script&lang=ts"

import "./QuestionnaireListComponent.vue?vue&type=style&index=0&id=6f4335bf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4335bf"]])

export default __exports__